import { apiClient } from "lib/apiClient";

export interface IRequireFixResearchCompRequest {
  compType: string;
  compId: string;
  workItemVersion: number;
  reviewNotes: string;
}

export const requireFixResearchComp = async ({
  compType,
  compId,
  workItemVersion,
  reviewNotes,
}: IRequireFixResearchCompRequest): Promise<void> => {
  await apiClient.post(`/reviews/comps/${compType}/${compId}/requires-fix`, {
    workItemVersion,
    reviewNotes,
  });
};
